import React, { useState } from "react";
import AssuranceSelector from "../components/assuranceSelector";
import Business from "./business";
import Family from "./family";
import Health from "./health";
import Heritage from "./heritage";
import RecaptchaLoginWrapper from "../components/Recaptcha/RecaptchaLoginWrapper"; // Importar el wrapper
import { useRecaptcha } from "../utils/useRecaptcha"; // Importar el hook
import {
  AssuranceOptionsContainer,
  Container,
  FormWrapper,
  MainTitle,
  Phrase,
  ProcessWrapper,
  StyledBlueButton,
  StyledTextInput,
  Subtitle,
  Wrapper,
  EmailContainer,
  ErrorMessage,
} from "./styled";
import Vehicle from "./vehicle";
import { ReactComponent as House } from "../assets/img/svg/confiansa_casa.svg";
import { ReactComponent as Heart } from "../assets/img/svg/corazon.svg";
import { ReactComponent as Car } from "../assets/img/svg/confiansa_carro 2.svg";
import { ReactComponent as Coins } from "../assets/img/svg/confiansa_dinero.svg";
import { ReactComponent as Shield } from "../assets/img/svg/segmedico.svg";

import Recommendation from "../components/recommendation";
import Contact from "../components/contact/contact";

import { validateEmail } from "../utils/validators";

const assuranceOptions = [
  {
    id: "family",
    icon: <Heart fill="#003865" />,
    text: "Mi Familia",
    border: "40px 0 0 0",
  },
  {
    id: "health",
    icon: <Shield fill="#003565" />,
    text: "Mi Salud",
    border: "0 0 0 0",
  },
  {
    id: "heritage",
    icon: <House fill="#003865" />,
    text: "Mi Patrimonio",
    border: "0 0 0 0",
  },
  {
    id: "business",
    icon: <Coins fill="#003865" />,
    text: "Mi Negocio",
    border: "0 0 0 0",
  },
  {
    id: "vehicle",
    icon: <Car fill="#003865" />,
    text: "Mi Vehículo",
    border: "0 0 40px 0",
  },
];

function MainWrapperContent() {
  const [step, setStep] = useState(0);
  const [selectedOption, setSelectedOption] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isProcessingRecaptcha, setIsProcessingRecaptcha] = useState(false);
  const [recommendation, setRecommendation] = useState({
    title: "",
    phrase1: "",
    prase2: "",
  });
  const [contact, setContact] = useState({
    name: null,
    phone: null,
    email: null,
  });
  const [assuranceUrl, setAssuranceUrl] = useState("");
  const [secondaryStep, setSecondaryStep] = useState(0);

  // Usar el hook de reCAPTCHA
  const { executeAndValidateRecaptcha } = useRecaptcha();

  const finishProcess = () => {
    setStep(3);
  };

  const startOver = () => {
    setStep(0);
  };

  const specificStep = (newSelectedOption, secondaryStep) => {
    setSelectedOption(newSelectedOption);
    setSecondaryStep(secondaryStep);
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setContact({ ...contact, email: emailValue });

    const error = validateEmail()(emailValue);
    setEmailError(error || "");
  };

  const isFormValid = () => {
    return selectedOption !== "" && contact.email !== "" && !emailError;
  };

  const handleStartTest = async () => {
    if (!isFormValid()) return;

    setIsProcessingRecaptcha(true);

    try {
      // Ejecutar reCAPTCHA
      const recaptchaResult = await executeAndValidateRecaptcha("start_test");

      if (recaptchaResult.success) {
        // Si reCAPTCHA es válido, proceder al siguiente paso
        setStep(1);
      } else {
        // Manejar error de reCAPTCHA
        console.error("Error de reCAPTCHA:", recaptchaResult.error);
        alert("Error de verificación. Por favor, intenta nuevamente.");
      }
    } catch (error) {
      console.error("Error al procesar reCAPTCHA:", error);
      alert("Error de verificación. Por favor, intenta nuevamente.");
    } finally {
      setIsProcessingRecaptcha(false);
    }
  };

  return (
    <>
      {step === 0 && (
        <Container>
          <Wrapper>
            <MainTitle>
              <strong>¡Descubre</strong> tu seguro ideal!
            </MainTitle>
            <Subtitle>
              Conoce las opciones de seguros que pueden ayudarte completando el
              siguiente test.
            </Subtitle>
            <Phrase>
              Selecciona qué te interesa proteger e ingresa tu correo para
              iniciar
            </Phrase>

            <AssuranceOptionsContainer style={{ marginTop: "30px" }}>
              {assuranceOptions.map((e) => (
                <AssuranceSelector
                  options={e}
                  key={e.text}
                  selected={e.id === selectedOption}
                  setSelectedOption={setSelectedOption}
                />
              ))}
            </AssuranceOptionsContainer>
            <AssuranceOptionsContainer style={{ marginTop: "50px" }}>
              <EmailContainer>
                <StyledTextInput
                  placeholder="Ingresa tu correo electrónico"
                  onChange={handleEmailChange}
                  style={{
                    borderColor: emailError ? "red" : "initial",
                  }}
                />
                {emailError && <ErrorMessage>{emailError}</ErrorMessage>}
              </EmailContainer>

              <StyledBlueButton
                onClick={handleStartTest}
                disabled={!isFormValid() || isProcessingRecaptcha}
              >
                {isProcessingRecaptcha ? "Verificando..." : "Iniciar el test"}
              </StyledBlueButton>
            </AssuranceOptionsContainer>
          </Wrapper>
        </Container>
      )}
      {step === 1 && (
        <FormWrapper>
          {selectedOption === "family" && (
            <Family
              finishProcess={finishProcess}
              setRecommendation={setRecommendation}
              setContact={setContact}
              contact={contact}
              startOver={startOver}
              setAssuranceUrl={setAssuranceUrl}
              specificStep={specificStep}
              secondaryStep={secondaryStep}
            />
          )}
          {selectedOption === "vehicle" && (
            <Vehicle
              finishProcess={finishProcess}
              setRecommendation={setRecommendation}
              startOver={startOver}
              setContact={setContact}
              contact={contact}
              setAssuranceUrl={setAssuranceUrl}
              secondaryStep={secondaryStep}
              specificStep={specificStep}
            />
          )}
          {selectedOption === "health" && (
            <Health
              finishProcess={finishProcess}
              setRecommendation={setRecommendation}
              startOver={startOver}
              setContact={setContact}
              contact={contact}
              setAssuranceUrl={setAssuranceUrl}
              secondaryStep={secondaryStep}
              specificStep={specificStep}
            />
          )}
          {selectedOption === "heritage" && (
            <Heritage
              finishProcess={finishProcess}
              setRecommendation={setRecommendation}
              startOver={startOver}
              setContact={setContact}
              contact={contact}
              setAssuranceUrl={setAssuranceUrl}
              secondaryStep={secondaryStep}
              specificStep={specificStep}
            />
          )}
          {selectedOption === "business" && (
            <Business
              finishProcess={finishProcess}
              setRecommendation={setRecommendation}
              startOver={startOver}
              setContact={setContact}
              contact={contact}
              setAssuranceUrl={setAssuranceUrl}
            />
          )}
        </FormWrapper>
      )}
      {step === 3 && (
        <FormWrapper>
          <ProcessWrapper>
            <Recommendation
              name={contact.name}
              recommendation={recommendation}
              startOver={startOver}
              url={assuranceUrl}
              contact={contact}
            />
          </ProcessWrapper>
        </FormWrapper>
      )}
    </>
  );
}

export default function MainWrapper() {
  return (
    <RecaptchaLoginWrapper>
      <MainWrapperContent />
    </RecaptchaLoginWrapper>
  );
}
